import React, { useEffect, useState } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {useCookies} from 'react-cookie';
import Header from "../components/header/Header";
import SearchBar from "../components/searchBar/SearchBar";
import { intervalLogging, stopLogging} from '../components/common/Logger';
import MajorLeagueBatterArea from "./league/MajorLeagueBatterArea";
import MinorLeagueBatterArea from "./league/MinorLeagueBatterArea";

function BatterPage() {
    const [cookies] = useCookies(['hiball_token']);
    const navigate = useNavigate();
    const location = useLocation();
    const {pathname} = location;
    const locationSplit = pathname.split('/');
    const leagueType = locationSplit[1];

    let [profile, setProfile] = useState({
        playerId: null, teamId: null, type: null, battingHand: null,
        birthdate: null
    });

    const { playerId } = useParams();

    useEffect(() => {
        if(leagueType !== 'major' && leagueType !== 'minor') {
            console.log(pathname);
            navigate('/major'+pathname);
        } 

        const season = new Date().getFullYear();
        let playerObj = {
            playerType: 'batter',
            playerId
        }
        stopLogging();
        intervalLogging(location.pathname, cookies['hiball_token'], playerObj);
        axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'digestRecord', recordName: 'selectProfile',
                batterIds: playerId,
                seasons: season,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        }).then((result) => {
            if(result.data.result.length < 1){
                navigate('/');
            } else {
                setProfile({
                    playerId: playerId,
                    teamId: result['data']['result'][0]['batter']['batterTeamId'],
                    type: 'batter',
                    battingHand: result['data']['result'][0]['batter']['battingHand'],
                    birthdate: result['data']['result'][0]['batter']['birthdate']
                });
            }
        });
    }, [])

    return (
        <>
        <Header title={'타자'}/>
        <Container fluid="xl" className="container">
            <Row>
                <SearchBar/>
            </Row>
            {
                leagueType === 'major'
                ?
                <MajorLeagueBatterArea profile={profile}/>
                :
                (
                leagueType === 'minor'
                ?
                <MinorLeagueBatterArea profile={profile}/>
                :
                <MajorLeagueBatterArea profile={profile}/>
                )
            }
        </Container>
        </>
    )
}

export default BatterPage;